import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { getDefaultLightTheme, GlobalTheme } from "@ui/theme/GlobalTheme"
import { SuperAdminPage } from "./view/pages/SuperAdminPage"
import { AdminGlobalStyle } from "./view/adminTheme"
import { ConfirmHost } from "./view/pages/confirm"
import { BackToTop } from "./view/pages/adminUi"

const theme = getDefaultLightTheme()
Object.assign(theme.colors, {
  backgroundPrimary: "#F1F1F4",
  textPrimary: "#0F0F13",
  textSecondary: "#565662",
  inputBorderPrimary: "#C6C6D0",
  inputBorderSecondary: "#5046E5",
  buttonBackgroundPrimary: "#0F0F13",
  buttonBackgroundPrimaryHover: "#2C2C33",
  buttonTextSecondary: "#0F0F13",
  divider: "#DFDFE6"
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GlobalTheme theme={theme}>
      <AdminGlobalStyle />
      <SuperAdminPage />
      <ConfirmHost />
      <BackToTop />
      <ToastContainer />
    </GlobalTheme>
  </StrictMode>
)
